import { API2_HOST } from 'helpers/urlHelper';
import axios from 'services/api';
export const getProductionItems = async date => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/prod-output-performance/product-items?date=${date}`
  });
};

export const getProductionQCs = async date => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/prod-output-performance/product-qcs?date=${date}`
  });
};

export const getProductionSCs = async date => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/prod-safety/product-scs?date=${date}`
  });
};

export const getSafetyStations = async () => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/prod-safety/stations`
  });
};

export const getAllStations = async () => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/ess-stations/stations`
  });
};

export const getProductionMCs = async date => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/prod-output-performance/product-mcs?date=${date}`
  });
};

export const getProductionErrors = async date => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/prod-output-performance/product-errors?date=${date}`
  });
};

export const getAncillariesProduction = async date => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/prod-output-performance/product-ancillary-items?date=${date}`
  });
};

export const getHardwareProduction = async date => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/prod-output-performance/product-hardware-items?date=${date}`
  });
};

export const getOutputPerformance = async date => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/prod-output-performance/output-performance?date=${date}`
  });
};

export const getRealdyToLoad = async date => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/prod-output-performance/ready-to-load?date=${date}`
  });
};

export const getOutputPerformanceMetadata = async () => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/prod-output-performance/output-performance/metadata`
  });
};

export const getNumberOfPieces = async date => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/prod-output-performance/number-of-pieces?date=${date}`
  });
};

export const getNumberOfFrameBoxes = async date => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/prod-output-performance/number-of-frame-boxes?date=${date}`
  });
};

export const getWeldedCillItems = async date => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/prod-output-performance/welded-cill?date=${date}`
  });
};

export const getCompositeDoorGearing = async date => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/prod-output-performance/composite-door-gearing?date=${date}`
  });
};

export const getHardwarePacking = async date => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/prod-output-performance/hardware-packing?date=${date}`
  });
};

export const getWeldedCillWelding = async date => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/prod-output-performance/welded-cill-welding?date=${date}`
  });
};

export const getRejectLogs = async date => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/prod-safety/alert-log-items?date=${date}`
  });
};
